import { render, staticRenderFns } from "./WikipediaPageForm.vue?vue&type=template&id=6156bf31&"
import script from "./WikipediaPageForm.vue?vue&type=script&lang=js&"
export * from "./WikipediaPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports